/// <reference types="./DatabaseSchema.d.ts" />
export const ENTITY_DIRTY_FLAG_VALIDATE_LATEST = 0x1;
export const ENTITY_DIRTY_FLAG_VALIDATE_PUBLISHED = 0x2;
export const ENTITY_DIRTY_FLAG_INDEX_LATEST = 0x4;
export const ENTITY_DIRTY_FLAG_INDEX_PUBLISHED = 0x8;
const AdvisoryLocksTable = 'advisory_locks';
const EntitiesTable = 'entities';
const PrincipalsTable = 'principals';
const UniqueIndexValuesTable = 'unique_index_values';
export const AdvisoryLocksUniqueNameConstraint = {
    table: AdvisoryLocksTable,
    columns: ['name'],
};
export const EntitiesUniqueNameConstraint = {
    table: EntitiesTable,
    columns: ['name'],
};
export const EntitiesUniquePublishedNameConstraint = {
    table: EntitiesTable,
    columns: ['published_name'],
};
export const EntitiesUniqueUuidConstraint = {
    table: EntitiesTable,
    columns: ['uuid'],
};
export const PrincipalsUniqueProviderIdentifierConstraint = {
    table: PrincipalsTable,
    columns: ['provider', 'identifier'],
};
export const UniqueIndexValueConstraint = {
    table: UniqueIndexValuesTable,
    columns: ['index_name', 'value'],
};
//# sourceMappingURL=DatabaseSchema.js.map